import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";

const EverythingYouNeedSection = () => {
  const features = [
    {
      id: 1,
      image: require("assets/images/nutrition1.png"),
      title: "Personalized Diet Plans",
      description: "Smart AI driven nutrition tailored to your body & goals.",
    },
    {
      id: 2,
      image: require("assets/images/nutrition2.png"),
      title: "Smart Food Tracking",
      description: "Log meals easily with calories, macros, and insights.",
    },
    {
      id: 3,
      image: require("assets/images/nutrition3.png"),
      title: "Recipe Recommendations",
      description: "Healthy, tasty recipes that fit your nutrition plan.",
    },
    {
      id: 4,
      image: require("assets/images/nutrition4.png"),
      title: "Progress Tracking & Analytics",
      description:
        "Easy to read charts to monitor calories, weight, and goals.",
    },
    {
      id: 5,
      image: require("assets/images/nutrition5.png"),
      title: "Meal Reminders",
      description: "Sync with Apple Health, Google Fit, or wearables.",
    },
    {
      id: 6,
      image: require("assets/images/nutrition6.png"),
      title: "Dietitian Support",
      description:
        "Backed by certified nutritionists & research driven insights.",
    },
  ];

  return (
    <Container maxWidth="xl" sx={{ py: 8, position: "relative", zIndex: 2 }}>
      {/* Section Header */}
      <Box sx={{ textAlign: "center", mb: 8 }}>
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "2.5rem", md: "40px" },
            fontWeight: 600,
            fontFamily: "Outfit",
            color: "#4ef4ff",
            mb: 3,
            lineHeight: 1.2,
          }}
        >
          Everything You Need for Smarter Nutrition
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: "1.1rem", md: "1.3rem" },
            fontWeight: 400,
            fontFamily: "Outfit",
            color: "rgba(255, 255, 255, 0.8)",
            lineHeight: 1.6,
            margin: "0 auto",
          }}
        >
          From personalized plans to powerful tracking Fitify gives you all the
          tools to achieve your health goals, all in one app.
        </Typography>
      </Box>

      {/* Feature Cards Grid */}
      <Box sx={{ position: "relative" }}>
        {/* Connecting Line with Stars */}
        <Box
          sx={{
            position: "absolute",
            top: { xs: "120px", md: "140px" },
            left: { xs: "5%", md: "8%" },
            right: { xs: "5%", md: "8%" },
            height: "2px",
            zIndex: 1,
            display: { xs: "none", md: "block" },
          }}
        >
          {/* Star Icons */}
          <Box
            sx={{
              position: "absolute",
              top: "-8px",
              left: "16.66%",
              width: "16px",
              height: "16px",
              background: "#4ef4ff",
              clipPath:
                "polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              top: "-8px",
              left: "50%",
              width: "16px",
              height: "16px",
              background: "#4ef4ff",
              clipPath:
                "polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              top: "-8px",
              right: "16.66%",
              width: "16px",
              height: "16px",
              background: "#4ef4ff",
              clipPath:
                "polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)",
            }}
          />
        </Box>

        {/* Feature Cards Grid */}
        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={feature.id}>
              <Box
                sx={{
                  backgroundColor: "rgba(45, 45, 45, 0.8)",
                  borderRadius: "15px",
                  padding: "24px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  zIndex: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "200px",
                    borderRadius: "12px",
                    overflow: "hidden",
                    mb: 3,
                  }}
                >
                  <Box
                    component="img"
                    src={feature.image}
                    alt={feature.title}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
                <Typography
                  sx={{
                    fontSize: "1.3rem",
                    fontWeight: 700,
                    fontFamily: "Outfit",
                    color: "#FFFFFF",
                    mb: 2,
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: 400,
                    fontFamily: "Outfit",
                    color: "rgba(255, 255, 255, 0.7)",
                    lineHeight: 1.5,
                  }}
                >
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default EverythingYouNeedSection;
